import styled from 'styled-components';
import theme from 'styles/theme';

export const ModalSubmitFeedback = styled.span`
  color: ${theme.colors.gray600};
  margin-right: 15px;
`;
